module.exports = __webpack_public_path__ + "img/just-upload.e4e220da.png";